import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["editor", "html", "text"];

    initialize() {
      // eslint-disable-next-line no-undef
      if (typeof Quill === "undefined") {
        location.reload();
      }
      // eslint-disable-next-line no-undef
      let quill = new Quill(this.editorTarget, {
        theme: "snow"
      });
      document.querySelector("form").onsubmit = function () {
        let description = document.querySelector("input[class=article-content]");
        description.value = quill.root.innerHTML;
      };
    }
}